import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3b7d3f31")
const _hoisted_1 = { class: "inquiry section-wrapper contents__area contents__area--terms" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "titleHead titleHead--terms" }, "お問い合わせ")
], -1)
const _hoisted_3 = { class: "formFrame formFrame--confirm" }
const _hoisted_4 = { class: "formFrame__list" }
const _hoisted_5 = { class: "formFrame__item inquiryForm__item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "companyName" }, "会社名")
], -1)
const _hoisted_7 = { class: "formFrame__item inquiryForm__item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "name" }, "担当者氏名")
], -1)
const _hoisted_9 = { class: "formFrame__item inquiryForm__item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "nameKana" }, "担当者氏名(ふりがな)")
], -1)
const _hoisted_11 = { class: "formFrame__item inquiryForm__item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "phoneNumber" }, "電話番号")
], -1)
const _hoisted_13 = { class: "formFrame__item inquiryForm__item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "email" }, "メールアドレス")
], -1)
const _hoisted_15 = { class: "formFrame__item inquiryForm__item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "email" }, "お問い合わせの種類")
], -1)
const _hoisted_17 = { class: "formFrame__item inquiryForm__item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "notes" }, "お問い合わせ内容")
], -1)
const _hoisted_19 = { style: {"text-align":"left","white-space":"pre-line"} }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"consentConfirm\" data-v-3b7d3f31><ul data-v-3b7d3f31><li class=\"detail\" data-v-3b7d3f31><i class=\"fas fa-exclamation-triangle\" data-v-3b7d3f31></i><div class=\"detailText\" data-v-3b7d3f31> メールアドレスをお間違えになると回答の送信ができません。 </div></li><li class=\"detail\" data-v-3b7d3f31><i class=\"fas fa-exclamation-triangle\" data-v-3b7d3f31></i><div class=\"detailText\" data-v-3b7d3f31> フォーム送信前にいま一度、正しいメールアドレスかどうかをご確認ください。 </div></li><li class=\"detail\" data-v-3b7d3f31><i class=\"fas fa-exclamation-triangle\" data-v-3b7d3f31></i><div class=\"detailText\" data-v-3b7d3f31> 迷惑メール対策を実施されている方は「@linku-s.com」のメールが受信できるように設定してください。 </div></li><li class=\"detail\" data-v-3b7d3f31><i class=\"fas fa-exclamation-triangle\" data-v-3b7d3f31></i><div class=\"detailText\" data-v-3b7d3f31> 一部のプロバイダー等では、メールサーバー上でメールをブロックしてしまうことがあります。その際は、ご利用のプロバイダーやメールサーバーの管理者にお問い合わせください。 </div></li></ul></div>", 1)
const _hoisted_21 = { class: "errorMessage" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 通信時にエラーが発生しました。 ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("再度お試しください。 ")
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "formButton" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "buttonItem__text" }, "戻る", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "buttonItem__text" }, "送信する", -1)
const _hoisted_32 = [
  _hoisted_31
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        method: "post",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
        class: "inquiryForm"
      }, [
        _createElementVNode("dl", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("dd", null, _toDisplayString(_ctx.inquiry.companyName), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("dd", null, _toDisplayString(_ctx.inquiry.name), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("dd", null, _toDisplayString(_ctx.inquiry.nameKana), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("dd", null, _toDisplayString(_ctx.inquiry.phoneNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("dd", null, _toDisplayString(_ctx.inquiry.email), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("dd", null, _toDisplayString(_ctx.inquiry.inquiryType), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("dd", _hoisted_19, _toDisplayString(_ctx.inquiry.notes), 1)
          ]),
          _hoisted_20
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("div", _hoisted_21, _hoisted_25, 512), [
            [_vShow, _ctx.isErrorOccurred]
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "buttonItem buttonItem--back",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
              disabled: _ctx.isInvokingApi
            }, _hoisted_29, 8, _hoisted_27),
            _createElementVNode("button", {
              type: "submit",
              class: "buttonItem buttonItem--result",
              disabled: _ctx.isInvokingApi
            }, _hoisted_32, 8, _hoisted_30)
          ])
        ])
      ], 32)
    ])
  ]))
}